import { lazy, Suspense } from 'react';

import { MicroFrontendLoaderProps } from './types';

const MicroFrontendLoaderV1 = lazy(() => import('./MicroFrontendLoaderV1'));
const MicroFrontendLoaderV2 = lazy(() => import('./MicroFrontendLoaderV2'));

// Loading fallback component
const LoadingFallback = () => (
    <div className='flex h-full items-center justify-center'>
        <div className='text-center'>
            <div className='border-slate-200 border-t-slate-600 mb-4 inline-block h-12 w-12 animate-spin rounded-full border-4'></div>
            <div className='text-slate-600'>
                <p className='font-medium'>Loading MicroFrontend...</p>
                <p className='mt-2 text-sm text-slate-500'>
                    Initializing component...
                </p>
            </div>
        </div>
    </div>
);

const MicroFrontendLoader = (props: MicroFrontendLoaderProps) => {
    const renderComponent = () => {
        const version = props.version || import.meta.env.VITE_MICRO_FRONTEND_LOADER_VERSION;
        switch (version) {
            case 'v2':
            case 'flexible':
                return <MicroFrontendLoaderV2 {...props} />;
            case 'v1':
            case 'legacy':
            default:
                return <MicroFrontendLoaderV1 {...props} />;
        }
    };

    return (
        <Suspense fallback={<LoadingFallback />}>
            {renderComponent()}
        </Suspense>
    );
};

export default MicroFrontendLoader;